import {
  Firestore,
  collection,
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore/lite";
import { DbBusinessWhatsappCustomHeader } from "./models";
import { firebaseDb } from "../../firebase/client-app";
import { axiosInstance } from "../../rest/axios";
import { getCookie } from "cookies-next";

export class WhatsAppCustomHeaderService {
  private businessPrivateRef(firestore: Firestore, businessId: string) {
    return collection(
      firestore,
      "businesses/" + businessId + "/business_private",
    );
  }

  async getWhatsAppCustomHeader(
    businessId: string,
    firestore: Firestore = firebaseDb,
  ) {
    const customHeader = await getDoc(
      doc(
        this.businessPrivateRef(firestore, businessId),
        "whatsapp_custom_header",
      ),
    );
    return customHeader.exists()
      ? (customHeader.data() as DbBusinessWhatsappCustomHeader)
      : null;
  }

  async saveWhatsAppCustomHeader(
    businessId: string,
    customHeader: DbBusinessWhatsappCustomHeader,
    firestore: Firestore = firebaseDb,
  ) {
    await setDoc(
      doc(
        this.businessPrivateRef(firestore, businessId),
        "whatsapp_custom_header",
      ),
      customHeader,
    );
  }

  async configureCustomHeader(
    businessId: string,
    customHeader: DbBusinessWhatsappCustomHeader,
  ) {
    await axiosInstance.post(
      "whatsapp/custom-header",
      {
        business_id: businessId,
        custom_header: customHeader,
      },
      {
        headers: { Authorization: getCookie("Authorization")?.toString() },
      },
    );
  }

  async regenerateEmbeddedSignupLink(businessId: string, appId: string) {
    const res = await axiosInstance.post(
      "_admin/whatsapp/custom-header/embed-link/regenerate",
      {
        business_id: businessId,
        app_id: appId,
      },
      {
        headers: { Authorization: getCookie("Authorization")?.toString() },
      },
    );
    return res.data;
  }

  async updateWhatsAppCustomHeader(
    businessId: string,
    appId: string,
    embeddedSignupLink: string,
    firestore: Firestore = firebaseDb,
  ) {
    await setDoc(
      doc(
        this.businessPrivateRef(firestore, businessId),
        "whatsapp_custom_header",
      ),
      {
        app_id: appId,
        embedded_signup_link: embeddedSignupLink,
      },
      { merge: true },
    );
  }

  async registerWebhook(appId: string) {
    await axiosInstance.post(
      "_admin/gupshup/register/webhook",
      {
        app_id: appId,
      },
      {
        headers: { Authorization: getCookie("Authorization")?.toString() },
      },
    );
  }

  async checkAndUpdateRegistration(appId: string) {
    try {
      const res = await axiosInstance.post(
        "/business/whatsapp/account/register",
        {
          app_id: appId,
        },
        {
          headers: { Authorization: getCookie("Authorization")?.toString() },
        },
      );
      return res.data;
    } catch (error: any) {
      return {
        status: "error",
      };
    }
  }

  async checkAndUpdateVerification(appId: string, businessId: string) {
    try {
      const res = await axiosInstance.post(
        "/business/whatsapp/account/verify",
        {
          app_id: appId,
          business_id: businessId,
        },
        {
          headers: { Authorization: getCookie("Authorization")?.toString() },
        },
      );
      return res.data;
    } catch (error: any) {
      return {
        status: "error",
      };
    }
  }
}

export const whatsAppCustomHeaderService = new WhatsAppCustomHeaderService();
